// removed by extract-text-webpack-plugin
module.exports = {"training":"_3-pAIz8rg5C6kyCUtTTfDF_0","body":"_2PW8xGVsEz8DVn825t5Rb_0","block":"_3eY7l5hg_qZ6nGNMksSK_K_0","short":"_2RwjLzbTy8et8YA5ljxmve_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a999c882","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Training/index.vue
// module id = cv7/
// module chunks = 1